/** Game plan email links (APS-259 step 4). */

const PATH_TOPICS: Record<string, string> = {
  '/subscription-required': 'upgrade',
  '/onboarding/quickStart': 'finish_signup',
  '/settings/connections': 'gmail',
};

/** The topic for a game plan link, or null when the link is not one. */
export function emailClickTopic(pathname: string, search: string): { topic: string; campaign: string | null } | null {
  const params = new URLSearchParams(search);
  if (params.get('utm_source') !== 'game_plan') return null;
  const topic = params.get('gp') || PATH_TOPICS[pathname] || pathname;
  return { topic, campaign: params.get('utm_campaign') };
}
